/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
import { useVueProps } from "common/vue/useVueProps";
/* eslint-disable max-lines-per-function */
import Stars from "common/vue/components/Stars.react.vue";
import "./PdpMadeReview.scss";

export default function PdpMadeReview(rawProps: any) {
  const { className, ...restProps } = rawProps;

  const props = useVueProps(rawProps);
  const { review, toggleTooltip } = props.current;

  return (
    <div
      {...(filterDomProps(restProps) as Record<string, unknown>)}
      className={cn("pdp-made-review scope-1e4f01e6", className)}
      role="button"
      tabIndex={0}
      aria-label={`View review by ${review.name}`}
      onClick={toggleTooltip}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleTooltip();
          (
            document.querySelector('[data-testid="pdp-made-reviews-rating"]') as HTMLElement
          )?.focus();
        }
      }}
      data-testid="pdp-made-review"
    >
      <div
        className={cn("pdp-made-review__side", "pdp-made-review__side--image", "scope-1e4f01e6")}
      >
        <div className={cn("pdp-made-review__image-wrap", "scope-1e4f01e6")}>
          <img
            className={cn("pdp-made-review__image", "scope-1e4f01e6")}
            alt="Review photo"
            src={review.image}
          />
        </div>
      </div>
      <div className={cn("pdp-made-review__side", "pdp-made-review__side--data", "scope-1e4f01e6")}>
        <header className={cn("pdp-made-review__header", "scope-1e4f01e6")}>
          <Stars
            className={cn("pdp-made-review__stars", "scope-1e4f01e6")}
            stars={review.rating}
            size="XS"
            data-testid="pdp-made-review-stars"
          />
          <span className={cn("pdp-made-review__author", "scope-1e4f01e6")}>
            From {review.name}, {review.created_at}
          </span>
        </header>
        <h4 className={cn("pdp-made-review__title", "scope-1e4f01e6")}>{review.title}</h4>
        <p className={cn("pdp-made-review__content", "scope-1e4f01e6")}>{review.review}</p>
      </div>
    </div>
  );
}
